<template>
  <v-main class="pa-4" fluid>
    <v-row>

      <v-snackbar v-model="alerta.activo" vertical top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>

      <v-col cols="12">
        <v-card  class="shadowCard" >
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Catálogos de Usuarios </span>
            <v-spacer></v-spacer>
            <v-btn color="primary"   dark class="mr-2" :to="{ name: 'newusuario' }"> Nuevo  </v-btn>
            <v-btn color="secondary" dark class="mr-2" @click="init()"> Actualizar    </v-btn>
            <!-- <v-btn color="warning"   dark class="mr-2" @click="exportar()"> <v-icon>save_alt</v-icon></v-btn> -->
            <v-btn color="success" dark @click="exportarInformacion()"> <v-icon>mdi-microsoft-excel</v-icon></v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :loading="loading"        
                  :headers="headers"
                  :items="usuarios"
                  class="elevation-0"
                  :search="search"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  dense
                >

                  <template v-slot:item="{ item }" >
                  <tr>
                      <td>{{ item.idusuariosweb }}</td>
                      <td>{{ item.nomper }}</td>
                      <td>{{ item.nomuser }}</td>
                      <td>{{ item.email }}</td>
                      <td>{{ item.nivel }}</td>
                      <td v-if="item.estatus == 2" class="green--text">ACTIVO</td>
                      <td v-if="item.estatus == 1" class="red--text">BAJA</td>
                      <td v-if="item.estatus == 0" class="orange--text">INACTIVO</td>
                      <td>
                        <v-btn color="success" fab small class="my-1 x-1" @click="modalUsuarios = true; parametros = item">
                          <v-icon >mdi-eye</v-icon>
                        </v-btn>
                        <v-btn color="grey" fab small dark class="my-1 mx-1" @click="modalPassword= true; parametros = item">
                          <v-icon >mdi-lock-outline</v-icon>
                        </v-btn>
                    </td>
                  </tr>
                          
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>

        </v-card>
      </v-col>

      <v-dialog v-model="modalUsuarios" width="500" >
        <v-card class="pa-4">
            <NewUsuario
              :parametros="parametros"
              @modal="modalUsuarios = $event;"
              @init="init()"
            />
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalPassword" width="400" >
        <v-card class="pa-4">
            <controlPassword
              :parametros="parametros"
              @modal="modalPassword = $event;"
              @init="init()"
            />
        </v-card>
      </v-dialog>

    </v-row>  
  </v-main>
</template>


<script>
  import  metodos from '@/mixins/metodos.js';
  import NewUsuario from '@/views/usuarios/NewUsuario.vue'
  import controlPassword from '@/views/usuarios/control_password.vue'

  var accounting = require("accounting");
  var md5     = require('md5')

  export default {
    mixins:[metodos],
    components: {
      NewUsuario,
      controlPassword
		},

    data: () => ({
      nombre: 'Catálogo-de-usuarios ',
      dialog: false,
      headers: [
        { text: 'ID', align: 'left',sortable: false, value: 'idusuariosweb' },
        { text: 'Nombre'  , value: 'nomper' },
        { text: 'Usuario'  , value: 'nomuser' },
        { text: 'Email'    , value: 'email' },
        { text: 'Nivel', value: 'nivel'},  
        { text: 'Estatus', value: 'estatus'},  
        { text: 'Editar', value: 'editar'},  
      ],
      page: 0,
      pageCount: 0,
      itemsPerPage: 100,
      
      search: '',
      loading: false,
      usuarios: [],

      alerta: { activo: false, texto:'', color:'error' },
      datosParaExportar:[],
      modalUsuarios: false,
      modalPassword: false,
      parametros:{}
           
    }),

    
    created () {
      this.init()
    },

    methods: {
 
      // EXCEL
      // exportar(){
      //   let xls = {
      //     data:      this.usuarios,
      //     tHeaders : ['ID', 'Usuario', 'Email', 'Cliente', 'Nombre Cliente', 'ID Vend', 'Vendedor', 'Nivel'],
      //     filterVal: ['idusuariosweb', 'Nomuser', 'Email', 'numcli', 'Nomcli', 'idvend', 'Nomvend', 'nivel'],
      //     nomfile :  "Consulta de Usuarios"
      //   }
      //   // console.log(xls)
      //    this.exportarXls(xls)
      // },

      exportarInformacion() {
        this.datosParaExportar = this.usuarios;
        this.exportToExcel(this.datosParaExportar, this.nombre)
      },


      init () {
        //Consultar Usuarios
        this.loading = true
        this.$http.get('users').then( response => {
          this.usuarios= response.body
        }).catch(error => {
          console.log(error)
        }).finally(()  => this.loading = false) 

      },  



    },

  }
</script>